import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const msg = (e) => (typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'No se pudo completar');

export const ManageDialog = ({ mode, method, onClose, onDone }) => {
  const { api } = useAuth();
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);

  const sendCode = async () => {
    try { await api.post('/security/2fa/manage-code'); toast.success('Código enviado a tu correo'); } catch (e) { toast.error(msg(e)); }
  };
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(mode === 'disable' ? '/security/2fa/disable' : '/security/2fa/recovery-codes', { password, code: code.trim() });
      toast.success(mode === 'disable' ? 'Doble factor desactivado' : 'Nuevos códigos generados');
      onDone(data);
    } catch (e) { toast.error(msg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="mfa-manage-dialog">
        <DialogHeader>
          <DialogTitle>{mode === 'disable' ? 'Desactivar doble factor' : 'Generar nuevos códigos de recuperación'}</DialogTitle>
          <DialogDescription>Confirma con tu contraseña y un código {method === 'email' ? 'enviado a tu correo' : 'de tu app autenticadora'} o de recuperación.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" data-testid="mfa-manage-password-input"
            className="w-full px-3 py-2 bg-slate-900/60 border border-slate-700 rounded-lg" />
          <div className="flex gap-2">
            <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Código" maxLength={13} data-testid="mfa-manage-code-input"
              className="flex-1 px-3 py-2 bg-slate-900/60 border border-slate-700 rounded-lg font-mono" />
            {method === 'email' && <button onClick={sendCode} data-testid="mfa-manage-send-code-btn" className="px-3 text-sm rounded-lg border border-slate-700 hover:bg-slate-800">Enviar código</button>}
          </div>
          <button onClick={submit} disabled={busy || !password || code.trim().length < 6} data-testid="mfa-manage-submit-btn"
            className={`w-full py-2 rounded-lg flex items-center justify-center gap-2 disabled:opacity-50 ${mode === 'disable' ? 'bg-rose-600 hover:bg-rose-500' : 'btn-primary'}`}>
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Confirmar
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
